export default __webpack_public_path__ + "static/media/T_Red.09768908.png";